import Vue from 'vue';
import store from './../../store';

// When the request succeeds
const success = (response, context) => {
    context.rentals = response.data.rentals;
    let rentalsLength = context.rentals.length;
    for (let i = 0; i < rentalsLength; i++) {
        context.userRentals.push({
            rental_id: context.rentals[i].id,
            access: 0,
        });
        context.rentals[i].status = 0;
    }
};

// When the request fails
const failed = (error, context) => {
    context.showToasterError(error);
    context.loading = false;
};

export default (context) => {
    return Vue.$http.get('/rentals')
        .then((response) => {
            if (response && response.status === 200) {
                success(response, context);
            } else {
                failed();
            }
        })
        .catch((error) => {
            failed(error, context);
        });
};



// WEBPACK FOOTER //
// ./src/app/services/team_member/getRentals.js